import { withStyles } from '@mui/styles';

import AddAcgNumberForm from './AddAcgNumberForm';
import muiStyles from './styles';

export default withStyles(muiStyles)(AddAcgNumberForm);